import { Incident } from '@haccp/api-client';

/**
 * Get CSS class for incident status badge
 */
export function getIncidentStatusClass(status: Incident['status']): string {
  switch (status) {
    case 'OPEN':
      return 'bg-red-50 text-red-700 border border-red-200';
    case 'CLOSED':
      return 'bg-green-50 text-green-700 border border-green-200';
    default:
      return 'bg-neutral-50 text-neutral-700 border border-neutral-200';
  }
}

/**
 * Get human-readable status text
 */
export function getIncidentStatusText(status: Incident['status']): string {
  switch (status) {
    case 'OPEN':
      return 'Ouvert';
    case 'CLOSED':
      return 'Résolu';
    default:
      return status;
  }
}

/**
 * Get indicator color for incident type
 */
export function getIncidentTypeColor(type: Incident['type']): string {
  switch (type) {
    case 'TEMPERATURE':
      return 'bg-blue-50 text-blue-700 border border-blue-200';
    default:
      return 'bg-neutral-50 text-neutral-700 border border-neutral-200';
  }
}

/**
 * Get human-readable incident type
 */
export function getIncidentTypeText(type: Incident['type']): string {
  switch (type) {
    case 'TEMPERATURE':
      return 'Dépassement température';
    default:
      return type;
  }
}

/**
 * Format incident date for display
 */
export function formatIncidentDate(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleDateString('fr-FR', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

/**
 * Format incident date and time
 */
export function formatIncidentDateTime(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleString('fr-FR', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/**
 * Get duration between opened and closed (if closed)
 */
export function getIncidentDuration(incident: Incident): string {
  if (!incident.closedAt) return 'En cours';

  const opened = new Date(incident.openedAt);
  const closed = new Date(incident.closedAt);
  const diffMs = closed.getTime() - opened.getTime();
  const diffMins = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffDays > 0) return `${diffDays}j ${diffHours % 24}h`;
  if (diffHours > 0) return `${diffHours}h ${diffMins % 60}m`;
  return `${diffMins}m`;
}
